<script setup>
import BackToTopButton from '@/Components/BackToTopButton.vue';
import { onMounted, ref, computed, defineAsyncComponent } from 'vue';
import { THEMES } from '@/constants';
import { usePage } from '@inertiajs/vue3';

const page = usePage();
const context = computed(() => page.props?.context);
const theme = context.value.theme;

const Header = computed(
  () => defineAsyncComponent(() => import(`./../Components/Navigation/${theme}/Header.vue`))
);

const Footer = computed(
  () => defineAsyncComponent(() => import(`./../Components/Navigation/${theme}/Footer.vue`))
);

const wrapperClasses = computed(() => [
  'w-full mx-auto',
  theme == THEMES.STUDY_MELB && 'bg-white max-w-[1440px]',
  theme == THEMES.STUDY_QLD && 'mt-[84px] min-[1200px]:mt-[146px]',
]);

const containerClasses = computed(() => [
  'py-6',
  theme == THEMES.STUDY_AUS && 'container mx-auto',
  theme == THEMES.STUDY_QLD && 'container mx-auto',
]);

// backtotop button causes window not defined
// dont mount til mounted so doesnt throw error
const loading = ref(true);
onMounted(() => {
  loading.value = false;
})
</script>
<template>
  <component :is="Header" />
  
  <main id="main-content" tabindex="-1" aria-label="Page content" :class="wrapperClasses">
    <div :class="containerClasses">
      <slot />
    </div>
  </main>

  <footer id="footer-content" tabindex="-1" aria-label="Page footer">
    <BackToTopButton v-if="!loading"></BackToTopButton>
    <component :is="Footer" />
  </footer>
</template>